import styled from 'styled-components';

const OTPForm = styled.div`
    text-align: center;

    .otp_wrap {
        padding: 0.625rem 0 1rem 0;
    }

    .otp_new {
        color:  ${props => props.theme.color};
        font-size: 1rem;
        margin-bottom: 2rem;
        display: inline-block;
        cursor: pointer;
    }

    .otp_new_disabled {
        color:  #dbdad7;
        font-size: 1rem;
        margin-bottom: 2rem;
        display: inline-block;
        cursor: pointer;
    }
`;

export default OTPForm;